/* LenBlu® PRO — animaciones y compra rápida (GSAP + ScrollTrigger + Lenis) */
(function () {
  if (window.__lbPro) return;
  window.__lbPro = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && Shopify.designMode;
  var hasG = function () { return window.gsap && window.ScrollTrigger; };
  var lenis = null;
  // Ronda 99: en pantallas táctiles el scroll es el del sistema; no se arranca el scroll suave (Lenis)
  var touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------------- Compra rápida ---------------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-lb-add');
    if (!id) return;
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading');
      if (res.status) { alert(res.description || (document.documentElement.lang === 'es' ? 'No se ha podido añadir' : 'Could not add to cart')); return; }
      btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2200);
      if (drawer && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: id, sections: res.sections });
      } else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
    }).catch(function () { btn.classList.remove('is-loading'); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb-add]');
    if (b) { e.preventDefault(); addToCart(b); }
  });

  /* ---------------- Cabecera ---------------- */
  function header() {
    var wrap = $('[data-lb-header]');
    if (!wrap) return;
    var last = 0;
    function onScroll(y) {
      wrap.classList.toggle('is-solid', y > 40);
      if (y > 260 && y > last + 4) wrap.classList.add('is-hidden');
      else if (y < last - 4 || y < 260) wrap.classList.remove('is-hidden');
      last = y;
    }
    window.addEventListener('scroll', function () { onScroll(window.scrollY); }, { passive: true });
    onScroll(window.scrollY);
    // avisos que rotan
    var msgs = $$('[data-lb-announce] span');
    if (msgs.length > 1 && !reduce) {
      var i = 0;
      setInterval(function () {
        var cur = msgs[i]; i = (i + 1) % msgs.length; var nxt = msgs[i];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        nxt.classList.remove('is-out'); nxt.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 700);
      }, 3800);
    }
    // menú móvil
    var menu = $('[data-lb-menu]');
    var openB = $('[data-lb-menu-open]');
    function setMenu(open) {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) menu.removeAttribute('inert'); else menu.setAttribute('inert', '');
      if (openB) openB.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (lenis) open ? lenis.stop() : lenis.start();
    }
    if (openB) openB.addEventListener('click', function () { setMenu(true); });
    $$('[data-lb-menu-close], [data-lb-menu] a').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* ---------------- Portada producto (cambio de color) ---------------- */
  function heroProduct() {
    $$('[data-lb-hp]').forEach(function (sec) {
      var sws = $$('.lb-sw', sec), prods = $$('.lb-hp__product', sec);
      var price = $('[data-lb-price]', sec), compare = $('[data-lb-compare]', sec);
      var add = $('[data-lb-add]', sec), detail = $('[data-lb-detail]', sec);
      var tagN = $('[data-lb-tagnum]', sec), tagL = $('[data-lb-taglabel]', sec);
      var cur = 0, timer = null;
      document.body.classList.toggle('lb-hero-light', sec.getAttribute('data-theme') === 'light');
      function show(i, user) {
        if (i === cur) return;
        var sw = sws[i];
        if (prods.length) {
          prods[cur].classList.remove('is-on'); prods[cur].classList.add('is-out');
          var prev = prods[cur]; setTimeout(function () { prev.classList.remove('is-out'); }, 900);
          if (prods[i]) prods[i].classList.add('is-on');
        }
        sws.forEach(function (s, j) { s.classList.toggle('is-on', j === i); s.setAttribute('aria-checked', j === i ? 'true' : 'false'); });
        sec.style.setProperty('--hp-bg', sw.dataset.bg);
        sec.style.setProperty('--hp-glow', sw.dataset.glow);
        sec.setAttribute('data-theme', sw.dataset.theme);
        document.body.classList.toggle('lb-hero-light', sw.dataset.theme === 'light');
        if (price) price.textContent = sw.dataset.price;
        if (compare) compare.textContent = sw.dataset.compare || '';
        if (add) add.setAttribute('data-lb-add', sw.dataset.variant);
        if (detail) detail.setAttribute('href', sw.dataset.url);
        if (tagN) tagN.textContent = '0' + (i + 1);
        if (tagL) tagL.textContent = sw.querySelector('span').textContent;
        cur = i;
        if (user) { clearInterval(timer); timer = null; }
      }
      sws.forEach(function (s, i) { s.addEventListener('click', function () { show(i, true); }); });
      // cambia solo cada 5 s hasta que el usuario elige
      if (sws.length > 1 && prods.length && !sec.classList.contains('lb-hp--photo') && !reduce && !design) timer = setInterval(function () { show((cur + 1) % sws.length); }, 5000);
      // inclinación con el ratón
      var stage = $('[data-lb-tilt]', sec);
      if (stage && hasG() && !reduce && window.matchMedia('(pointer: fine)').matches) {
        var rx = gsap.quickTo(stage, 'rotationX', { duration: .8, ease: 'power3' });
        var ry = gsap.quickTo(stage, 'rotationY', { duration: .8, ease: 'power3' });
        sec.addEventListener('mousemove', function (e) {
          var r = sec.getBoundingClientRect();
          ry(((e.clientX - r.left) / r.width - .5) * 14);
          rx(-((e.clientY - r.top) / r.height - .5) * 10);
        });
        sec.addEventListener('mouseleave', function () { rx(0); ry(0); });
      }
      if (stage && hasG() && !reduce) {
        gsap.to(stage, { yPercent: -12, scale: 1.06, ease: 'none', scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom top', scrub: true } });
        gsap.to($('.lb-hp__ghost', sec), { xPercent: -18, ease: 'none', scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom top', scrub: true } });
      }
    });
  }

  /* ---------------- Texto letra a letra ---------------- */
  function splitChars(el) {
    if (el.dataset.split) return $$('.lb-char', el);
    el.dataset.split = '1';
    // Respeta los saltos de línea (<br>) que vengan en el titular
    var lines = el.innerHTML.split(/<br\s*\/?>/i).map(function (h) { var t = document.createElement('div'); t.innerHTML = h; return t.textContent.trim(); }).filter(Boolean);
    el.setAttribute('aria-label', lines.join(' '));
    el.innerHTML = lines.map(function (line) {
      return line.split(/\s+/).map(function (w) {
        return '<span class="lb-wordwrap" aria-hidden="true">' + w.split('').map(function (c) { return '<span class="lb-char">' + c + '</span>'; }).join('') + '</span>';
      }).join(' ');
    }).join('<br>');
    return $$('.lb-char', el);
  }

  /* ---------------- Animaciones de scroll ---------------- */
  function motion() {
    var html = document.documentElement;
    if (!hasG() || reduce) { html.classList.remove('lb-pre'); return; }
    gsap.registerPlugin(ScrollTrigger);
    // Ronda 99: en el móvil, que la barra de Safari al esconderse no obligue a recalcular todo
    if (touch && ScrollTrigger.config) ScrollTrigger.config({ ignoreMobileResize: true });
    html.classList.add('lb-gsap');

    $$('[data-a="chars"]').forEach(function (el) {
      if (el.closest('[data-lb-hp]')) return;
      var chars = splitChars(el);
      var inHero = el.closest('[data-lb-hp]');
      gsap.from(chars, {
        yPercent: 120, opacity: 0, rotate: 6, duration: 1.1, ease: 'expo.out', stagger: .018,
        delay: inHero ? (document.documentElement.classList.contains('lb-no-intro') ? .2 : 1.9) : 0,
        scrollTrigger: inHero ? null : { trigger: el, start: 'top 85%' }
      });
    });
    $$('[data-a="fade"]').forEach(function (el) {
      if (el.closest('[data-lb-hp]')) return;
      var inHero = el.closest('[data-lb-hp]');
      gsap.fromTo(el, { y: 36, opacity: 0 }, {
        y: 0, opacity: 1, duration: 1.2, ease: 'expo.out',
        delay: inHero ? (document.documentElement.classList.contains('lb-no-intro') ? .5 : 2.2) : 0,
        scrollTrigger: inHero ? null : { trigger: el, start: 'top 88%' }
      });
    });
    $$('[data-a="stagger"]').forEach(function (el) {
      gsap.fromTo(el.children, { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 1.2, ease: 'expo.out', stagger: .1, scrollTrigger: { trigger: el, start: 'top 85%' } });
    });
    $$('[data-a="clip"]').forEach(function (el) {
      gsap.fromTo(el, { clipPath: 'inset(18% 10% 18% 10% round 22px)' }, { clipPath: 'inset(0% 0% 0% 0% round 22px)', ease: 'none', scrollTrigger: { trigger: el, start: 'top 90%', end: 'top 30%', scrub: true } });
    });
    $$('[data-a="scrub-up"]').forEach(function (el) {
      gsap.fromTo(el, { y: 120, rotate: -6, scale: .9 }, { y: -40, rotate: 0, scale: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    // Foto que crece
    $$('[data-lb-zoom]').forEach(function (sec) {
      var media = $('[data-lb-zoom-media]', sec), img = $('img', media), text = $('.lb-zoom__text', sec), cap = $('[data-lb-zoom-caption]', sec);
      var isM = window.innerWidth < 750;
      var tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: .6 } });
      tl.fromTo(media, { clipPath: isM ? 'inset(52% 12% 10% 12% round 20px)' : 'inset(46% 34% 8% 34% round 24px)' }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'power2.inOut', duration: 1 }, 0)
        .fromTo(img, { scale: 1.25 }, { scale: 1, ease: 'none', duration: 1 }, 0)
        .to(text, { yPercent: -80, opacity: 0, ease: 'power2.in', duration: .32 }, 0)
        .fromTo(cap, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: .25 }, .8);
    });

    // Anatomía
    $$('[data-lb-anat]').forEach(function (sec) {
      var calls = $$('[data-lb-callout]', sec), bar = $('[data-lb-anat-bar]', sec), stage = $('.lb-anat__stage', sec);
      var tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: .5 } });
      tl.fromTo(stage, { scale: 1.25, y: 40 }, { scale: 1, y: 0, duration: 1, ease: 'power2.out' }, 0);
      calls.forEach(function (c, i) {
        var at = .6 + i * .55;
        tl.fromTo(c, { opacity: 0 }, { opacity: 1, duration: .2 }, at)
          .fromTo($('.lb-callout__line', c), { scaleY: 0 }, { scaleY: 1, duration: .3 }, at)
          .fromTo($('.lb-callout__txt', c), { y: 16, opacity: 0 }, { y: 0, opacity: 1, duration: .3 }, at + .15);
      });
      tl.to({}, { duration: .6 });
      if (bar) tl.fromTo(bar, { scaleX: 0 }, { scaleX: 1, ease: 'none', duration: tl.duration() }, 0);
    });

    html.classList.remove('lb-pre');

    // Botones magnéticos
    if (window.matchMedia('(pointer: fine)').matches) {
      $$('[data-magnetic]').forEach(function (b) {
        var x = gsap.quickTo(b, 'x', { duration: .5, ease: 'power3' }), y = gsap.quickTo(b, 'y', { duration: .5, ease: 'power3' });
        b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); x((e.clientX - r.left - r.width / 2) * .25); y((e.clientY - r.top - r.height / 2) * .35); });
        b.addEventListener('mouseleave', function () { x(0); y(0); });
      });
    }
  }

  /* ---------------- Anatomía: cambio de color ---------------- */
  function anatomyToggle() {
    $$('[data-lb-anat]').forEach(function (sec) {
      $$('[data-lb-anat-color]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          var c = b.dataset.lbAnatColor;
          $$('[data-lb-anat-color]', sec).forEach(function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
          $$('.lb-anat__img', sec).forEach(function (im) { im.classList.toggle('is-on', im.dataset.c === c); });
          sec.classList.toggle('is-light', c === 'n');
        });
      });
    });
  }

  /* ---------------- Carril arrastrable ---------------- */
  function rails() {
    $$('[data-lb-rail]').forEach(function (r) {
      var down = false, sx = 0, sl = 0, moved = 0, aim = null, aimT = 0, tick = false, settle = null;
      var nav = r.id ? $('[data-lb-rail-nav] [aria-controls="' + r.id + '"]') : null;
      nav = nav ? nav.parentNode : null;
      var prev = nav ? $('[data-lb-rail-prev]', nav) : null, next = nav ? $('[data-lb-rail-next]', nav) : null;
      function cards() { return Array.prototype.slice.call(r.children); }
      function num(v) { return parseFloat(v) || 0; }
      // margen con el que descansa la primera tarjeta (scroll-padding; si no lo hay, el relleno del carril)
      function pad() { var cs = getComputedStyle(r); return num(cs.scrollPaddingLeft) || num(cs.paddingLeft); }
      function max() { return Math.max(0, r.scrollWidth - r.clientWidth); }
      // posición de scroll que deja la tarjeta i alineada con el margen
      function posOf(i) { var c = cards()[i]; if (!c) return 0; return c.getBoundingClientRect().left - r.getBoundingClientRect().left + r.scrollLeft - pad(); }
      function nearest() { var best = 0, bd = Infinity, x = r.scrollLeft; cards().forEach(function (c, i) { var d = Math.abs(posOf(i) - x); if (d < bd) { bd = d; best = i; } }); return best; }
      // tarjetas enteras que caben a la vez
      function perPage() {
        var c = cards(); if (c.length < 2) return 1;
        var step = c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
        var cs = getComputedStyle(r), inner = r.clientWidth - num(cs.paddingLeft) - num(cs.paddingRight);
        return step > 0 ? Math.max(1, Math.floor((inner + (step - c[0].getBoundingClientRect().width) + 1) / step)) : 1;
      }
      function to(i, smooth) {
        var n = cards().length; i = Math.max(0, Math.min(n - 1, i));
        aim = i; aimT = Date.now();
        r.scrollTo({ left: Math.max(0, Math.min(max(), posOf(i))), behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }
      function go(dir) {
        // varias pulsaciones seguidas cuentan desde el destino pendiente, no desde donde va la animación
        var base = (aim !== null && Date.now() - aimT < 700) ? aim : nearest();
        var per = perPage(), last = Math.max(0, cards().length - per);
        to(Math.max(0, Math.min(last, Math.min(base, last) + dir * per)), true);
      }
      function setOff(b, off) { if (b) b.setAttribute('aria-disabled', off ? 'true' : 'false'); }
      function update() {
        if (!nav) return;
        var m = max(), x = r.scrollLeft;
        nav.hidden = m < 2;
        setOff(prev, x <= 1); setOff(next, x >= m - 1);
      }
      if (nav) {
        [prev, next].forEach(function (b, k) {
          if (!b) return;
          b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') === 'true') return; go(k ? 1 : -1); });
        });
        r.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; update(); }); }, { passive: true });
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        update();
      }
      // arrastre con el ratón: se mueve con la mano y, al soltar, encaja con suavidad en la tarjeta más cercana
      function release() {
        clearTimeout(settle);
        r.classList.remove('is-dragging');
      }
      r.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = 0; sx = e.clientX; sl = r.scrollLeft; });
      r.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
        if (moved > 6) { clearTimeout(settle); r.classList.add('is-dragging'); r.scrollLeft = sl - dx; }
      });
      function up() {
        if (!down) return; down = false;
        if (!r.classList.contains('is-dragging')) return;
        var i = nearest(), dx = r.scrollLeft - sl;
        // un arrastre corto pero decidido pasa a la tarjeta siguiente o anterior
        if (Math.abs(dx) > 40 && Math.abs(posOf(i) - sl) < 2) i += dx > 0 ? 1 : -1;
        to(i, true);
        settle = setTimeout(release, reduce ? 30 : 650);
      }
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
      // si se ha arrastrado, el clic no abre el enlace
      r.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } moved = 0; }, true);
      $$('img, a', r).forEach(function (el) { el.setAttribute('draggable', 'false'); });
      // la rueda vertical la sigue gestionando el scroll suave (evita tirones al pasar por el carril);
      // el gesto horizontal del trackpad lo deja pasar Lenis y mueve el carril de forma nativa
    });
  }

  /* ---------------- Barra de compra fija ---------------- */
  function stickyBuy() {
    var bar = $('[data-lb-stickybuy]'), main = $('[data-lb-mainbuy]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    // Ordenador: aparece al pasar el botón principal. Móvil (<= 749 px): visible desde que se abre la ficha,
    // oculta mientras el botón principal está a la vista, mientras el cajón de la cesta está abierto
    // y (ronda 87) mientras el visor de fotos ampliadas está abierto (html.lb-lbox-open).
    var mq = window.matchMedia('(max-width: 749px)'), drawer = $('cart-drawer'), seen = true, past = false;
    var root = document.documentElement, lbox = root.classList.contains('lb-lbox-open');
    function render() {
      var phone = mq.matches, open = !!drawer && drawer.classList.contains('active');
      var on = phone ? (!seen && !open && !lbox) : past;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      var btn = $('button', bar); if (btn) btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('lb-sb-on', on && phone);
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        seen = e.isIntersecting; past = !e.isIntersecting && e.boundingClientRect.top < 0;
        render();
      });
    }).observe(main);
    if (drawer && 'MutationObserver' in window) new MutationObserver(render).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    // visor de fotos: solo se vuelve a pintar cuando cambia su estado (render también toca clases de <html>)
    if ('MutationObserver' in window) new MutationObserver(function () {
      var now = root.classList.contains('lb-lbox-open');
      if (now !== lbox) { lbox = now; render(); }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    if (mq.addEventListener) mq.addEventListener('change', render); else if (mq.addListener) mq.addListener(render);
  }

  /* ---------------- Ronda 99: el scroll nunca se queda bloqueado ---------------- */
  // Pase lo que pase al cerrar el menú o la cesta (toque fuera, Escape, volver atrás), se comprueba el estado real
  // y se suelta lo que haya quedado bloqueado. También marca <html> mientras la cesta está abierta (lb-cart-open).
  function locks() {
    var root = document.documentElement, drawer = $('cart-drawer'), menu = $('[data-lb-menu]');
    function sync() {
      var cart = !!drawer && drawer.classList.contains('active');
      var m = !!menu && menu.classList.contains('is-open');
      var lb = root.classList.contains('lb-lbox-open');
      if (root.classList.contains('lb-cart-open') !== cart) root.classList.toggle('lb-cart-open', cart);
      if (!m && root.style.overflow === 'hidden') root.style.overflow = '';
      if (!m && !lb && lenis && lenis.isStopped) lenis.start();
    }
    if (drawer && 'MutationObserver' in window) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('pageshow', sync);
    window.addEventListener('popstate', sync);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(sync, 0); });
    sync();
  }

  /* ---------------- Intro ---------------- */
  function intro(done) {
    var el = $('[data-lb-intro]');
    if (!el || document.documentElement.classList.contains('lb-no-intro') || reduce || design || !hasG()) {
      if (el) el.style.display = 'none';
      document.documentElement.classList.add('lb-no-intro');
      return done();
    }
    // La intro es CSS (snippets/lb-intro.liquid + lb.css): aquí no se anima
    done();
  }

  /* ---------------- Arranque ---------------- */
  function start() {
    if (hasG() && window.Lenis && !reduce && !design && !touch) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.lenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"], a[href^="/#"]');
        if (!a) return;
        var id = a.getAttribute('href').split('#')[1];
        var t = id && document.getElementById(id);
        if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -80 }); }
      });
    }
    // Ronda 99: en táctil, los enlaces a un punto de la misma página bajan con suavidad sin Lenis
    if (touch && !lenis) document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      var id = a.getAttribute('href').split('#')[1];
      var t = id && document.getElementById(id);
      if (t) { e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior: reduce ? 'auto' : 'smooth' }); }
    });
    header(); anatomyToggle(); rails(); stickyBuy(); locks();
    // Ronda 99: si alguien tocó «Añadir a la cesta» antes de que llegara este archivo, se atiende ahora
    if (window.__lbQ) { var q = window.__lbQ; window.__lbQ = null; if (document.contains(q)) addToCart(q); }
    intro(function () { heroProduct(); motion(); });
    window.addEventListener('load', function () {
      if (window.lbReload && !window.lbTouched) { window.scrollTo(0, 0); if (lenis) lenis.scrollTo(0, { immediate: true }); }
      if (hasG()) ScrollTrigger.refresh();
    });
    if (window.lbReload && !window.lbTouched && lenis) lenis.scrollTo(0, { immediate: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { if (hasG()) ScrollTrigger.refresh(); });
})();

/* ================= Ronda 12: visor de fotos de producto (ampliar) ================= */
(function () {
  if (window.__lbLightbox) return; window.__lbLightbox = true;
  // 26-10: el mismo visor sirve para la galería y para la tira de miniaturas («Mírala por todos lados»)
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-lb-gallery], [data-lb-angles]'), setup); }
  function setup(gal) {
    var isStrip = gal.hasAttribute('data-lb-angles');
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('img'));
    if (!imgs.length) return;
    var box = document.createElement('div');
    box.className = 'lb-lbox'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Fotos del producto');
    box.innerHTML = '<button type="button" class="lb-lbox__close" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="lb-lbox__nav lb-lbox__prev" aria-label="Foto anterior">&#8249;</button>' +
      '<img class="lb-lbox__img" alt="">' +
      '<button type="button" class="lb-lbox__nav lb-lbox__next" aria-label="Foto siguiente">&#8250;</button>' +
      '<p class="lb-lbox__count"></p>';
    document.body.appendChild(box);
    var big = box.querySelector('.lb-lbox__img'), count = box.querySelector('.lb-lbox__count'), i = 0, lastFocus = null, seq = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      var im = imgs[i], my = ++seq;
      var full = (window.matchMedia && window.matchMedia('(max-width: 989px)').matches && im.getAttribute('data-full-m')) || im.getAttribute('data-full') || im.currentSrc || im.src; // Ronda 102: en móvil la primera foto es la vertical
      // Primero la misma foto que ya está cargada en la página (instantánea); luego la grande.
      // Así nunca se ve un momento la foto que se abrió antes.
      var quick = (im.complete && im.naturalWidth) ? (im.currentSrc || im.src) : '';
      big.alt = im.alt || '';
      count.textContent = (i + 1) + ' / ' + imgs.length;
      if (quick) big.src = quick; else big.removeAttribute('src');
      if (full && full !== quick) {
        var pre = new Image();
        pre.onload = function () { if (my === seq) big.src = full; };
        pre.src = full;
      }
    }
    function open(n) {
      lastFocus = document.activeElement; show(n);
      box.classList.add('is-open'); document.documentElement.classList.add('lb-lbox-open');
      if (window.lenis && window.lenis.stop) window.lenis.stop();
      box.querySelector('.lb-lbox__close').focus();
    }
    function close() {
      box.classList.remove('is-open'); document.documentElement.classList.remove('lb-lbox-open');
      if (window.lenis && window.lenis.start) window.lenis.start();
      if (lastFocus) lastFocus.focus();
    }
    // En móvil la galería se desliza: si se toca justo al terminar de deslizar, se abre la foto centrada
    var lastScroll = 0;
    gal.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
    function centered(fallback) {
      if (gal.scrollWidth <= gal.clientWidth + 2) return fallback;
      var r = gal.getBoundingClientRect(), cx = r.left + r.width / 2, best = fallback, bd = 1e9;
      imgs.forEach(function (im, k) { var b = im.getBoundingClientRect(); if (!b.width) return; var d = Math.abs(b.left + b.width / 2 - cx); if (d < bd) { bd = d; best = k; } });
      return best;
    }
    imgs.forEach(function (im, n) {
      im.style.cursor = 'zoom-in'; im.setAttribute('tabindex', '0'); im.setAttribute('role', 'button');
      im.addEventListener('click', function () { open(!isStrip && Date.now() - lastScroll < 300 ? centered(n) : n); });
      im.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(n); } });
    });
    box.querySelector('.lb-lbox__close').addEventListener('click', close);
    box.querySelector('.lb-lbox__prev').addEventListener('click', function () { show(i - 1); });
    box.querySelector('.lb-lbox__next').addEventListener('click', function () { show(i + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ================= Ronda 102: galería de la ficha en móvil (puntos indicadores) ================= */
(function () {
  if (window.__lbGalDots) return; window.__lbGalDots = true;
  function init() {
    var gal = document.querySelector('[data-lb-gallery]');
    if (!gal || !gal.classList.contains('lb-pdp2__gallery')) return;
    var figs = Array.prototype.slice.call(gal.children).filter(function (f) { return f.tagName === 'FIGURE'; });
    if (figs.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'lb-pdp2__dots'; dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = figs.map(function () { return '<i></i>'; }).join('');
    gal.insertAdjacentElement('afterend', dots);
    if (gal.parentNode.classList.contains('lb-pdp2__grid')) gal.parentNode.classList.add('has-dots');
    var marks = dots.children, cur = -1, tick = 0;
    function set(n) { if (n === cur) return; cur = n; for (var k = 0; k < marks.length; k++) marks[k].classList.toggle('is-on', k === n); }
    function upd() {
      tick = 0;
      var max = gal.scrollWidth - gal.clientWidth, x = gal.scrollLeft;
      if (max <= 2) return; // rejilla de ordenador: no hay nada que contar
      if (x <= 2) return set(0);
      if (x >= max - 2) return set(figs.length - 1);
      var gr = gal.getBoundingClientRect(), c = gr.left + gr.width / 2, best = 0, bd = 1e9;
      figs.forEach(function (f, k) { var b = f.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - c); if (d < bd) { bd = d; best = k; } });
      set(best);
    }
    gal.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', function () { if (!tick) tick = requestAnimationFrame(upd); }, { passive: true });
    set(0); upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
